import React, { type ReactNode } from "react";
import { FormattedMessage } from "react-intl";
import { GQL } from "@binale-tech/shared";

export type ColorItem = {
    key: GQL.IDocumentColors;
    label: ReactNode;
    icon: ReactNode;
};

export const documentColorHex: Record<GQL.IDocumentColors, string> = {
    [GQL.IDocumentColors.Red]: "rgba(237, 27, 53, 0.9)",
    [GQL.IDocumentColors.Green]: "rgba(68, 184, 92, 0.9)",
    [GQL.IDocumentColors.Purple]: "rgba(142, 71, 156, 0.9)",
    [GQL.IDocumentColors.Yellow]: "rgba(255, 203, 49, 0.9)",
    [GQL.IDocumentColors.Blue]: "rgba(30, 153, 229, 0.9)",
};

const items: ColorItem[] = Object.values(GQL.IDocumentColors).map((el) => ({
    key: el,
    label: <FormattedMessage tagName="div" id={`app.button.color.${el}`} />,
    // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop -- module-scope value computed once; not a per-render prop
    icon: <div className="h-3.5 w-3.5 rounded-full" style={{ backgroundColor: documentColorHex[el] }} />,
}));

export const useColorItems = (): ColorItem[] => items;
